import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ProductCardComponent } from '../../pages/products/cards/product-card.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ProductCardComponent, HomeComponent],
  imports: [CommonModule, HomeRoutingModule, TranslateModule],
  exports: [],
})
export class HomeModule {}
